// extracted by mini-css-extract-plugin
module.exports = {"check-box-input-wrapper":"check-box-input-wrapper___jHw1","error":"error__21rFA"};